import { Paragraph } from '@zillow/constellation-10';

const WizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        To protect your identity, the phone number renters see will differ from your actual number. You&apos;ll receive
        calls and texts like normal, but your information is protected.
      </Paragraph>
    </div>
  );
};

export default WizardTipContent;
